const materials = [
    {
        name: 'Poster',
        material: 'poster',
    },
    {
        name: 'Forex',
        material: 'forex',
    },
    {
        name: 'Dibond',
        material: 'dibond',
    },
    {
        name: 'Puzzel',
        material: 'puzzle',
    },
];

export default materials;